module.exports = __webpack_public_path__ + "static/media/System_Boundary-envelopes.11118427.png";